import type { VersionSummary } from '../lib/api'
import { el } from '../lib/dom'
import { replayPath } from '../router'
import { formatReal } from '../components/replay/replayState'

const relative = (epochSeconds: number, now = Date.now()): string => {
  const minutes = Math.round((now / 1000 - epochSeconds) / 60)
  if (minutes < 2) return 'just now'
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.round(minutes / 60)
  if (hours < 48) return `${hours}h ago`
  return `${Math.round(hours / 24)}d ago`
}

const avatar = (v: VersionSummary): HTMLElement =>
  v.avatarUrl
    ? el('img', {
        class: 'avatar',
        src: v.avatarUrl,
        alt: '',
        width: 32,
        height: 32,
        loading: 'lazy',
      })
    : el('span', { class: 'avatar avatar-empty', 'aria-hidden': 'true' })

const card = (v: VersionSummary): HTMLElement =>
  el(
    'li',
    { class: 'version-card' },
    el(
      'a',
      { href: replayPath(v.id), 'data-link': true, class: 'version-link' },
      avatar(v),
      el(
        'span',
        { class: 'version-meta' },
        el('span', { class: 'version-handle' }, `~${v.handle}`),
        el(
          'span',
          { class: 'version-sub' },
          `${v.tokens} tokens · typed over ${formatReal(v.realMs)} · ${relative(v.createdAt)}`,
        ),
      ),
      el('span', { class: 'version-cta' }, 'replay ▶'),
    ),
  )

/** The list of plots to wander into. Replays are the point, so each row is one. */
export const createVersionList = (versions: readonly VersionSummary[]): HTMLElement => {
  if (versions.length === 0) {
    return el('p', { class: 'empty' }, 'No plots yet. The first one gets the whole town to itself.')
  }
  return el('ol', { class: 'version-list' }, ...versions.map(card))
}
